//import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthState } from './auth';
import { useOperatorsState } from './OperatorsList';

const PublicRoutes = (props: any) => {
  const { isAuthenticated, isLoading } = useAuthState();
  const { loggedUserData } = useOperatorsState();
  console.log('loggedUserData', loggedUserData);
  console.log(isLoading);

  let url = '/operators/';
  if (loggedUserData?.operatorId > 0) {
    url += loggedUserData?.operatorId;
  }

  return loggedUserData && isAuthenticated && !isLoading ? <Navigate to={url} /> : <Outlet />;
};

export default PublicRoutes;
